import { put, takeLatest } from 'redux-saga/effects';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { updateCourseSuccess, updateCourseFailed } from '../actions';
import { getAllCourses } from 'redux/courses/actions';
import { CoursesActionTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* updateCourse({ data }) {
  const { payload, callBack } = data;
  const { id } = payload;

  const url = `${API_BASE_URL}/courses/${id}`;
  const response = yield request({
    method: 'put',
    data: payload,
    url,
  });
  if (response.success) {
    if (callBack && typeof callBack === 'function') {
      callBack();
    }
    yield put(updateCourseSuccess({ ...response.raw, status: payload.status }));
    Notify('Course Updated Successfully!', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
  } else {
    yield put(updateCourseFailed(response.message));
    const errorMesssage = response.statusCode === 409 ? `The course code "${payload.code.toUpperCase()}" is already in use` : response.message;
    networkErrorHandler(response?.statusCode, errorMesssage);
  }
}

export function* onCourseUpdate() {
  yield takeLatest(CoursesActionTypes.UPDATE_COURSE, updateCourse);
}

function* toggleCourseStatus({ data: { payload, cb } }) {
  const { id } = payload;

  const url = `${API_BASE_URL}/courses/${id}`;

  const response = yield request({
    method: 'patch',
    data: {
      status: payload.status,
    },
    url,
  });
  if (response.success) {
    yield put(updateCourseSuccess(response.raw));
    yield put(getAllCourses());
    Notify(
      `Course ${
        payload.status === 'active' ? 'Activated' : 'Disabled'
      } Successfully!`,
      {
        position: TOP_RIGHT,
        status: SUCCESS,
      }
    );
    if (cb && typeof cb === 'function') {
      cb();
    }
  } else {
    yield put(updateCourseFailed(response.message));
    networkErrorHandler(response?.statusCode, response?.message);
  }
}

export function* onCourseDisabled() {
  yield takeLatest(CoursesActionTypes.DISABLES_COURSE, toggleCourseStatus);
}
